<template>
  <DefaultPageContainer
    :cnc-ads-page="cncAdsPage"
    :breadcrumb-text="$t('newsletter.breadcrumbs')"
  >
    <section class="section lg:w-10/12 mx-auto min-h-[50vh]">
      <!-- title -->
      <h3 class="h3" v-html="$t('newsletter.title')" />

      <!-- Content -->
      <div class="pt-2"
         v-html="$t('newsletter.perex')"
      />

      <!-- Newsletters -->
      <div class="newsletter__list">
        <DefaultNewsletterCard
          v-for="(newsletter, index) in newsletters"
          :newsletter="newsletter"
          :key="`newsletter-card-${index}`"
          @subscribe="onNewsletterSelected"
        />
      </div>

      <UModal
        v-model="isSubscribeModalOpen"
        :ui="{ width: 'sm:max-w-2xl' }"
      >
        <button
          class="newsletter__close-button"
          @click="closeModal"
        >
          <DefaultIconsCross />
        </button>
        <DefaultNewsletterSubscribeForm
          v-if="selectedNewsletter"
          :newsletter="selectedNewsletter"
          @close="closeModal"
        />
      </UModal>
    </section>
  </DefaultPageContainer>
</template>

<script setup lang="ts">
import {CncAdsPage} from "~/libs/constants/CncAdsPage"
import {useI18n} from "vue-i18n"
import {useHtmlToPlainText} from "~/composables/useHtmlToPlainText"
import {useNewsletterConfig} from "~/composables/useNewsletterConfig"
import type NewsletterLocal from "~/libs/interfaces/NewsletterLocal"

// i18n routing
definePageMeta({
  name: 'newsletter',
})
false && /*#__PURE__*/ defineI18nRoute({
  paths: {
    cs: '/newsletter',
    en: '/newsletter'
  }
})

const config = useRuntimeConfig()
const route = useRoute()
const {t} = useI18n()
const cncAdsPage = CncAdsPage.NEWSLETTER
const localePath = useLocalePath()

if (!config.public.smartEmailing?.enabled) {
  throw createError({
    statusCode: 404,
    statusMessage: 'Page Not Found'
  })
}

const isSubscribeModalOpen = ref(false)
const selectedNewsletter = ref<NewsletterLocal|undefined>(undefined)

const newsletters = useNewsletterConfig().getNewsletterList()

// Set SEO meta
useSeoWrapper().setSeoMeta({
  title: useHtmlToPlainText(t('newsletter.title')),
})

const onNewsletterSelected = (payload: any) => {
  selectedNewsletter.value = useNewsletterConfig().getNewsletterByContactListId(payload.id)
  openModal()
}

const openModal = () => {
  isSubscribeModalOpen.value = true
}

const closeModal = () => {
  isSubscribeModalOpen.value = false
}

/**
 * On mounted - load data client
 */
onMounted(async () => {
  /**
   * CncAds Page change
   */
  useCncAdsWrapper().changePageAds(cncAdsPage, {
    route: route
  })

})
</script>
